import { api } from "@/lib/api";
import type { AuthResponse, LoginRequest, GoogleLoginRequest, MeResponse, RegisterRequest } from "@/types/api";

export const authApi = {
  login: (body: LoginRequest) => api.post<AuthResponse>("/api/auth/login", body),
  register: (body: RegisterRequest) => api.post<AuthResponse>("/api/auth/register", body),
  google: (body: GoogleLoginRequest) => api.post<AuthResponse>("/api/auth/google", body),
  me: () => api.get<MeResponse>("/api/auth/me"),
};
